export const REQUEST_TEMPLATES_WHATSAPP = 'REQUEST_TEMPLATES_WHATSAPP'
export const REQUEST_TEMPLATES_WHATSAPP_SUCESS = 'REQUEST_TEMPLATES_WHATSAPP_SUCESS'

export const CHECK_USER_ACTIVE = 'CHECK_USER_ACTIVE'